import { useState } from "react";
import { Link } from "react-router-dom";
import { faqItems } from "@/mocks/faq";

export default function FaqSection() {
  const shown = faqItems.slice(0, 4);
  const [open, setOpen] = useState<number>(0);

  return (
    <section
      id="faq"
      className="mx-auto w-full max-w-[1400px] px-4 py-14 md:px-6 md:py-20"
    >
      <div className="mx-auto max-w-3xl text-center">
        <h2 className="font-heading text-2xl font-bold text-foreground-50 md:text-3xl">
          常见问题
        </h2>
        <p className="mt-2 text-sm text-foreground-500">
          关于追更、阅读与分类的常见疑问，这里都有答案
        </p>
      </div>

      <div className="mx-auto mt-8 max-w-3xl space-y-3">
        {shown.map((item, i) => (
          <div
            key={item.q}
            className="overflow-hidden rounded-lg border border-background-200/60 bg-background-100"
          >
            <button
              type="button"
              onClick={() => setOpen(open === i ? -1 : i)}
              className="flex w-full cursor-pointer items-center justify-between gap-4 px-4 py-4 text-left md:px-5"
            >
              <span className="text-sm font-semibold text-foreground-100 md:text-base">
                {item.q}
              </span>
              <i
                className={`ri-add-line text-lg text-accent-300 transition-transform ${
                  open === i ? "rotate-45" : ""
                }`}
                aria-hidden="true"
              ></i>
            </button>
            {open === i && (
              <p className="border-t border-background-200/50 px-4 py-4 text-sm leading-relaxed text-foreground-500 md:px-5">
                {item.a}
              </p>
            )}
          </div>
        ))}
      </div>

      <div className="mt-6 text-center">
        <Link
          to="/faq"
          className="inline-flex cursor-pointer items-center gap-2 whitespace-nowrap text-sm font-medium text-accent-300 transition-colors hover:text-accent-200"
        >
          查看全部常见问题
          <i className="ri-arrow-right-line" aria-hidden="true"></i>
        </Link>
      </div>
    </section>
  );
}